import icon from 'assets/img/icons/special-offers.svg'
import iconPrediction from "assets/img/icons/craft-prediction.svg";
import { Link } from 'react-router-dom'

const PlaceholderBlockProfile = ({type = 'default'}) => {

  return (
    <section className="craft-placeholder">
      <img src={icon} alt="placeholder icon" className="placeholder-block__icon" />
      <h5 className="placeholder-block__title">No Activity</h5>
      {
        type === 'prediction' &&
        <Link className="craft-placeholder__button" to='/inventory/predictions'>
          <img src={iconPrediction} alt="" />
          Craft Prediction
        </Link>
      }
    </section>
  )
}

export default PlaceholderBlockProfile
